import { useRef, useState } from "react";
import { Col, Container, Form, Row } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";

function CreateFixedSharedSafariModal({ showFixed, handleCloseFixed }) {
  const [currentStep, setCurrentStep] = useState(1);

  // Step 1 States
  const [title, setTitle] = useState("");
  const [parkId, setParkId] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [number, setNumber] = useState("");
  const [maxPrice, setMaxPrice] = useState("");
  const [totalSeat, setTotalSeat] = useState("");
  const [shareSeat, setShareSeat] = useState("");
  const [cutDate, setCutDate] = useState("");
  const [safariNumber, setSafariNumber] = useState("");
  const [usedSeats, setUsedSeats] = useState("");

  const [titleError, setTitleError] = useState(false);
  const [parkError, setParkError] = useState(false);
  const [dateError, setDateError] = useState(false);
  const [endDateError, setEndDateError] = useState(false);
  const [numberError, setNumberError] = useState(false);
  const [maxPriceError, setMaxPriceError] = useState(false);
  const [totaleSeatError, setTotalSeatError] = useState(false);
  const [shareSeatError, setShareSeatError] = useState(false);
  const [mobileNumber, setMobileNumber] = useState("");
  const [mobileNumberError, setMobileNumberError] = useState(false);
  const [cutDateError, setCutDateError] = useState(false);
  const [safariNumberError, setSafariNumberError] = useState(false);
  const [usedSeatsError, setUsedSeatsError] = useState(false);
  const [otp, setOtp] = useState(["", "", "", ""]);
  const otpRefs = [useRef(), useRef(), useRef(), useRef()];
  const handleVerify = () => {
    handleNext();
  };
  const [value, setValue] = useState(1); // Initial value

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    // console.log("Selected file:", file);
  };
  const validateStep1 = () => {
    const titleValid = title.trim() !== "";
    const parkValid = parkId !== "";
    const startDateValid = startDate !== "";
    const endDateValid = endDate !== "";
    const cutDateValid = cutDate !== "";
    const safariNumberValid = safariNumber !== "";

    setTitleError(!titleValid);
    setParkError(!parkValid);
    setDateError(!startDateValid);
    setEndDateError(!endDateValid);
    setCutDateError(!cutDateValid);
    setSafariNumberError(!safariNumberValid);

    return (
      titleValid &&
      parkValid &&
      startDateValid &&
      endDateValid &&
      cutDateValid &&
      safariNumberValid
    );
  };

  const validateStep2 = () => {
    const numberValid = number.trim() !== "";
    const totalSeatValid = totalSeat.trim() !== "";
    const usedSeatsValid = usedSeats.trim() !== "";
   

    setNumberError(!numberValid);
    setUsedSeatsError(!usedSeatsValid);
    setTotalSeatError(!totalSeat);

    return numberValid  && totalSeatValid  &&  usedSeatsValid ;
  };
  // const validateStep3 = () => {
  //   return true;
  // };
  // const validateStep4 = () => {
  //   return true;
  // };
  // const validateStep5 = () => {
  //   return true;
  // };

  // const handleTotalSeatChange = (e) => {
  //   const value = e.target.value;
  //   setTotalSeat(value);
  //   setShareSeat(""); // reset share seat whenever total seat changes
  //   setTotalSeatError(value.trim() === "");
  // };

  // const handleShareSeatChange = (e) => {
  //   setShareSeat(e.target.value);
  //   setShareSeatError(e.target.value.trim() === "");
  // };

  const generateShareSeatOptions = () => {
    const total = parseInt(totalSeat);
    if (isNaN(total) || total <= 0) return [];
    return Array.from({ length: total - 1 }, (_, i) => i + 1);
  };

  const handleNext = () => {
    if (currentStep === 1 && validateStep1()) {
      setCurrentStep(2);
    } else if (currentStep === 2 && validateStep2()) {
      setCurrentStep(3);
    }
    // } else if (currentStep === 3 && validateStep3()) {
    //   setCurrentStep(4);
    // } else if (currentStep === 4 && validateStep4()) {
    //   setCurrentStep(5);
    // } else if (currentStep === 5 && validateStep5()) {
    //   setCurrentStep(6);
    // }
  };

  const handleBack = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  const renderStep1 = () => (
    <Row className="pt-3">
      <Col xs={12} className="mb-2">
        <label className="Modal_label">
          Title <span className="necessary">*</span>
        </label>
        <div className="mb-3 field-sharedsafariform-share_safari_title required">
          <input
            type="text"
            className={`form-control ${titleError ? "is-invalid" : ""}`}
            placeholder="Enter Title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            onBlur={() => setTitleError(title.trim() === "")}
          />
          {titleError && (
            <div className="invalid-feedback">Title is required</div>
          )}
        </div>
      </Col>
      <Col xs={12} className="mb-2">
        <label className="Modal_label">
          Select a Safari Park <span className="necessary">*</span>
        </label>
        <div className="mb-3 field-sharedsafariform-park_id required">
          <select
            className={`form-control ${parkError ? "is-invalid" : ""}`}
            value={parkId}
            onChange={(e) => setParkId(e.target.value)}
            onBlur={() => setParkError(parkId === "")}
          >
            <option value="">Select a Safari Park</option>
            <option value="6">Bandhavgarh Tiger Reserve</option>
            <option value="7">Kanha Tiger Reserve</option>
            <option value="64">Ranthambore Tiger Reserve</option>
          </select>
          {parkError && (
            <div className="invalid-feedback">Park is required</div>
          )}
        </div>
      </Col>
      <Col xs={12}>
        <div className="start w-100">
          <label className="Modal_label">
            Cut of Date <span className="necessary">*</span>
          </label>
          <div className="mb-3 field-sharedsafariform-start_date required">
            <input
              type="date"
              className={`form-control ${cutDateError ? "is-invalid" : ""}`}
              value={cutDate}
              onChange={(e) => setCutDate(e.target.value)}
              onBlur={() => setCutDateError(cutDate === "")}
            />
            {cutDateError && (
              <div className="invalid-feedback">Cut of date is required</div>
            )}
          </div>
        </div>
      </Col>
      <Col xs={12}>
        <div className="start w-100">
          <label className="Modal_label">
            Start Date <span className="necessary">*</span>
          </label>
          <div className="mb-3 field-sharedsafariform-start_date required">
            <input
              type="date"
              className={`form-control ${dateError ? "is-invalid" : ""}`}
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              onBlur={() => setDateError(startDate === "")}
            />
            {dateError && (
              <div className="invalid-feedback">Start date is required</div>
            )}
          </div>
        </div>
      </Col>
      <Col xs={12}>
        <div className="start w-100">
          <label className="Modal_label">
            End Date <span className="necessary">*</span>
          </label>
          <div className="mb-3 field-sharedsafariform-start_date required">
            <input
              type="date"
              className={`form-control ${endDateError ? "is-invalid" : ""}`}
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              onBlur={() => setEndDateError(endDate === "")}
            />
            {endDateError && (
              <div className="invalid-feedback">End date is required</div>
            )}
          </div>
        </div>
      </Col>
      <Col xs={12} className="mb-1">
        <label className="Modal_label">Number of Safaris</label>
        <div className="mb-3 field-sharedsafariform-no_of_safari required">
          <input
            type="number"
            placeholder="Enter Number Of Safari"
            min="0"
            max="10"
            value={safariNumber}
            onChange={(e) => setSafariNumber(e.target.value)}
            className={`form-control ${safariNumberError ? "is-invalid" : ""}`}
            onBlur={() => setSafariNumberError(safariNumber === "")}
          />

          {safariNumberError && (
            <div className="invalid-feedback">No Of Safari:Required</div>
          )}
        </div>
      </Col>
    </Row>
  );

  const renderStep2 = () => (
    <Row className="pt-3">
      <Col md={12} className="mb-1">
        <label for="" className="Modal_label">
          Theme <span className="necessary">*</span>
        </label>
        <div className="mb-3 field-sharedsafariform-share_safari_agenda_id required">
          <select
            name=""
            id=""
            className="form-select form-select-lg mb-3 is-valid"
          >
            <option value="1">Photography</option>
            <option value="2">Safari Experience</option>
          </select>
        </div>
      </Col>
      <Col md={12} className="mb-1">
        <label for="" className="Modal_label">
          Accommodation
        </label>
        <div className="mb-3 field-sharedsafariform-share_safari_agenda_id required">
          <select
            name=""
            id=""
            className="form-select form-select-lg mb-3 is-valid"
          >
            <option value="">Select</option>
            <option value="1">Premium</option>
            <option value="2">Standard</option>
            <option value="3">Economical</option>
            <option value="4">Not Included</option>
          </select>
        </div>
      </Col>
      <Col md={12} className="mb-2">
        <label for="" className="Modal_label">
          Cost Per Person (INR) <span className="necessary">*</span>
        </label>
        {/* <div className="d-flex gap-3 align-items-center"> */}
        <div className="mb-3 field-sharedsafariform-estimate_price_min required">
          <input
            type="number"
            className={`form-control ${numberError ? "is-invalid" : ""}`}
            value={number}
            onChange={(e) => setNumber(e.target.value)}
            onBlur={() =>
              setNumberError(
                number.trim() === "" || isNaN(number) || Number(number) <= 0
              )
            }
            placeholder="1000"
          />

          {numberError && (
            <div className="invalid-feedback">Price Min : Required</div>
          )}
        </div>
        {/* <span>-</span>
          <div className="mb-3 field-sharedsafariform-estimate_price_max required">
            <input
              type="number"
              className={`form-control ${maxPriceError ? "is-invalid" : ""}`}
              onChange={(e) => setMaxPrice(e.target.value)}
              onBlur={() =>
                setMaxPriceError(
                  maxPrice.trim() === "" ||
                    isNaN(maxPrice) ||
                    Number(maxPrice) <= 0
                )
              }
              min="0"
              placeholder="2000"
              aria-required="true"
              aria-invalid="true"
            />
            {maxPriceError && (
              <div class="invalid-feedback">Price Max : Required</div>
            )}
          </div> */}
        {/* </div> */}
      </Col>
      <Col xs={12} className="mb-2">
        <label className="Modal_label">
          Total Seats <span className="necessary">*</span>
        </label>
        <div className="mb-3 field-sharedsafariform-share_safari_title required">
          <input
            type="number"
            min="0"
            max="10"
            className={`form-control ${totaleSeatError ? "is-invalid" : ""}`}
            placeholder="Enter Title"
            value={totalSeat}
            onChange={(e) => setTotalSeat(e.target.value)}
            onBlur={() => setTotalSeatError(totalSeat.trim() === "")}
          />
          {setTotalSeatError && (
            <div className="invalid-feedback">Share Seat:Required</div>
          )}
        </div>
      </Col>
      {/* <Col md={12}>
        <div className="selects w-100">
          <label for="" className="Modal_label">
            Total Seat <span class="necessary">*</span>
          </label>
          <div className="mb-3 field-sharedsafariform-total_seat required">
            <select
              name="SharedSafariForm"
              className={`form-control ${totaleSeatError ? "is-invalid" : ""}`}
              onChange={handleTotalSeatChange}
              onBlur={() => setTotalSeatError(String(totalSeat).trim() === "")}
            >
              <option value="">Total Seat</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5">5</option>
              <option value="6">6</option>
              <option value="7">7</option>
            </select>
            {totaleSeatError && (
              <div class="invalid-feedback">Total Seat:Required</div>
            )}
          </div>
        </div>
      </Col> */}
      <Col xs={12} className="mb-2">
        <label className="Modal_label">
          Seats Used <span className="necessary">*</span>
        </label>
        <div className="mb-3 field-sharedsafariform-share_safari_title required">
          <input
            type="number"
            min="0"
            max="10"
            className={`form-control ${usedSeatsError ? "is-invalid" : ""}`}
            placeholder="Enter Title"
            value={usedSeats}
            onChange={(e) => setUsedSeats(e.target.value)}
            onBlur={() => setUsedSeatsError(usedSeats.trim() === "")}
          />
          {usedSeatsError && (
            <div className="invalid-feedback">Share Seat:Required</div>
          )}
        </div>
      </Col>
      {/* <Col md={12}>
        <div className="selects w-100">
          <label htmlFor="sharedsafariform-share_seat" className="Modal_label">
            Seats Used <span className="necessary">*</span>
          </label>
          <div className="mb-3 field-sharedsafariform-share_seat required">
            <select
              className={`form-select form-select-lg mb-3 ${
                shareSeatError ? "is-invalid" : ""
              }`}
              name="SharedSafariForm"
              value={shareSeat}
              onChange={handleShareSeatChange}
              onBlur={() => setShareSeatError(shareSeat.trim() === "")}
            >
              <option value="">Select Shared Seat</option>
              {generateShareSeatOptions().map((opt) => (
                <option key={opt} value={opt}>
                  {opt}
                </option>
              ))}
            </select>
            {shareSeatError && (
              <div className="invalid-feedback">Share Seat: Required</div>
            )}
          </div>
        </div>
      </Col> */}
    </Row>
  );

  const renderStep3 = () => (
    <Row className="pt-3">
      <Col xs={6} className="mobileSetimg mb-2">
        <label for="" class="Modal_label">
          Current Display Image
        </label>
        <img
          src="https://d281t0xjcq032r.cloudfront.net/safaripark/39/park_feature_image1719689492.jpg"
          id="park_image"
          alt=""
          width="100%"
          height="100px"
          style={{ objectFit: "contain" }}
        />
      </Col>
      <Col xs={6} className="mb-2">
        <label htmlFor="fileInput" class="Modal_label">
          Select Picture
        </label>
        <input
          type="file"
          id="fileInput"
          className="form-control"
          onChange={handleFileChange}
        />
      </Col>
      <Col xs={12}>
        <label for="" class="Modal_label">
          Plan{" "}
        </label>
        <textarea
          name=""
          id=""
          className="form-control"
          placeholder="Enter Page Detail!"
          style={{ height: "160px" }}
        ></textarea>
      </Col>
    </Row>
  );
  // const renderStep4 = () => (
  //   <Row className="pt-3">
  //     <Col xs={12} className="mb-3 text-center">
  //       <label className="Modal_label text-center">
  //         {" "}
  //         Mobile Number Verification
  //       </label>
  //       <p className="font_colorfomr">
  //         "A One Time Passcode will be sent to your mobile number."
  //       </p>
  //     </Col>
  //     <Col xs={12} className="mb-2">
  //       <label className="Modal_label">
  //         Mobile Number <span className="necessary">*</span>
  //       </label>
  //       <div className="mb-3 field-sharedsafariform-share_safari_title required">
  //         <input
  //           type="tel"
  //           className={`form-control ${mobileNumberError ? "is-invalid" : ""}`}
  //           placeholder="Enter number"
  //           value={mobileNumber}
  //           onChange={(e) => setMobileNumber(e.target.value)}
  //         />
  //         {mobileNumberError && (
  //           <div className="invalid-feedback">Mobile number is required</div>
  //         )}
  //       </div>
  //     </Col>
  //   </Row>
  // );
  // const renderStep5 = () => (
  //   <Row className="pt-3">
  //     <Col xs={12} className="mb-3 text-center">
  //       <label className="Modal_label text-center">
  //         Mobile Number Verification
  //       </label>
  //       <p className="font_colorfomr px-lg-5">
  //         We will send you a One Time Passcode on this Mobile Number
  //       </p>
  //       <label className="Modal_label text-center">
  //         +91-9090909090{" "}
  //         <span>
  //           <button className="changebtn ms-2">Change</button>
  //         </span>
  //       </label>
  //     </Col>

  //     <Col xs={12} className="mb-3 d-flex justify-content-center gap-2">
  //       {otp.map((digit, index) => (
  //         <input
  //           key={index}
  //           type="text"
  //           maxLength={1}
  //           className="form-control text-center"
  //           style={{ width: "50px", fontSize: "24px" }}
  //           value={digit}
  //           ref={otpRefs[index]}
  //           onChange={(e) => {
  //             const val = e.target.value;
  //             if (/^[0-9]$/.test(val) || val === "") {
  //               const newOtp = [...otp];
  //               newOtp[index] = val;
  //               setOtp(newOtp);

  //               if (val !== "" && index < otp.length - 1) {
  //                 otpRefs[index + 1].current.focus();
  //               }
  //             }
  //           }}
  //           onKeyDown={(e) => {
  //             if (e.key === "Backspace" && otp[index] === "" && index > 0) {
  //               otpRefs[index - 1].current.focus();
  //             }
  //           }}
  //         />
  //       ))}
  //     </Col>
  //     <Col xs={12} className="text-center m-auto">
  //       <button
  //         className="changebtn d-block text-center m-auto"
  //         style={{ fontStyle: "italic" }}
  //       >
  //         Resend OTP
  //       </button>
  //     </Col>
  //   </Row>
  // );
  // const renderStep6 = () => (
  //   <Row className="pt-3">
  //     <Col xs={12} className="mb-3 text-center">
  //       <label className="Modal_label text-center">
  //         Mobile Number Verification
  //       </label>
  //       <p className="font_colorfomr px-lg-5">
  //         We will send you a One Time Passcode on this Mobile Number
  //       </p>
  //       <label className="Modal_label text-center">
  //         +91-9090909090{" "}
  //         <span>
  //           <button className="changebtn ms-2">Change</button>
  //         </span>
  //       </label>
  //     </Col>

  //     <Col xs={12} className="mb-3 text-center mt-4">
  //       <h3 className="mb-0" style={{ fontStyle: "italic" }}>
  //         Thank you"
  //       </h3>
  //       <p style={{ fontStyle: "italic" }}>
  //         Your OTP has been verified successfully.
  //       </p>
  //     </Col>
  //   </Row>
  // );

  return (
    <Modal show={showFixed} onHide={handleCloseFixed} centered>
      <Modal.Header className="justify-content-center">
        <h2 className="modal-title fs-5">Create Fixed Departure</h2>
      </Modal.Header>
      <Modal.Body className="px-3 pt-0">
        <div className="py-3 px-2">
          <Container fluid="lg">
            <Form>
              {currentStep === 1 && renderStep1()}
              {currentStep === 2 && renderStep2()}
              {currentStep === 3 && renderStep3()}
              {/* {currentStep === 4 && renderStep4()}
              {currentStep === 5 && renderStep5()}
              {currentStep === 6 && renderStep6()} */}
            </Form>
            <Row>
              <Col lg={12} className="margin-remove pt-3">
                <div className="creat-safri d-flex justify-content-end">
                  {currentStep === 1 ? (
                    <button className="cancel_btn" onClick={handleCloseFixed}>
                      Cancel
                    </button>
                  ) : (
                    <button className="cancel_btn" onClick={handleBack}>
                      Back
                    </button>
                  )}

                  {currentStep < 5 ? (
                    <button
                      className="btn safari_create font_set w-auto ms-2 next_screen"
                      onClick={handleNext}
                    >
                      Next
                    </button>
                  ) : currentStep === 5 ? (
                    <button
                      className="btn safari_create font_set w-auto ms-2 next_screen"
                      onClick={handleVerify}
                    >
                      Verify
                    </button>
                  ) : (
                    <button className="btn safari_create font_set w-auto ms-2 next_screen">
                      Create
                    </button>
                  )}
                </div>
              </Col>
            </Row>

            <div className="dots-container text-center mt-3">
              <span
                className={`dot ${currentStep === 1 ? "active" : ""}`}
                onClick={handleBack}
              ></span>
              <span
                className={`dot ${currentStep === 2 ? "active" : ""}`}
                onClick={handleBack}
              ></span>
              <span
                className={`dot ${currentStep === 3 ? "active" : ""}`}
                onClick={handleBack}
              ></span>
              {/* <span
                className={`dot ${currentStep === 4 ? "active" : ""}`}
                onClick={handleBack}
              ></span>
              <span
                className={`dot ${currentStep === 5 ? "active" : ""}`}
                onClick={handleBack}
              ></span>
              <span
                className={`dot ${currentStep === 6 ? "active" : ""}`}
                onClick={handleBack}
              ></span> */}
            </div>
          </Container>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default CreateFixedSharedSafariModal;
